import { render } from "./TournamentBrackets.vue?vue&type=template&id=4d8e99fb&ts=true"
import script from "./TournamentBrackets.vue?vue&type=script&lang=ts"
export * from "./TournamentBrackets.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__